module.exports = [{"name":"samsung","regex":".*SamsungBrowser\\/(\\d+)\\.(\\d+)"},{"name":"orange","regex":"SOPOpenBrowser"}]